import axios from 'axios';

/*
 * SETUP
 * -----
 */

const baseUrl =
  window.location.host === 'wheelseye.com' || window.location.hostname === 'localhost'
    ? 'https://wheelseye.com' // Production URL
    : 'https://stage.wheelseye.in'; // Staging URL

export const getTeammates = (token, serviceTypes) => {
  let url = `${baseUrl}/operator/teammates`;
  if (!!token) {
    url += `?token=${token}`;
    if (!!serviceTypes) {
      url += `&serviceTypes=${serviceTypes}`;
    }
  } else {
    if (!!serviceTypes) {
      url += `?serviceTypes=${serviceTypes}`;
    }
  }
  return axios
    .get(url)
    .then((response) => {
      // console.log(response);
      return response;
    })
    .catch((error) => {
      // console.log(error);
      return Promise.reject(error);
    });
};
